import { render, staticRenderFns } from "./HistoryTraceNormalInfo.vue?vue&type=template&id=3dd23084&"
import script from "./HistoryTraceNormalInfo.vue?vue&type=script&lang=js&"
export * from "./HistoryTraceNormalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports